import Nullstack from 'nullstack';
export default function IconArrowLeftRight({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-left-right",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 13l4 -4l-4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M7 13l-4 -4l4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M12 14a5 5 0 0 1 5 -5h4"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v-5a5 5 0 0 0 -5 -5h-4"
  }), " ");
}